import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const EcofriendlyGiftsforcorporategifting =()=>{
    const CTAContent = [
        {
          pageName: "Eco-Friendly Gifts for Corporate Gifting ",
          paragraphitalic: "Sustainability with Style",
          paragraphText:
                "Corporate gifting doesn’t have to come at the expense of the planet. With our eco-friendly corporate gifts, you can show your commitment to the environment while strengthening your brand’s reputation. From biodegradable products to reusable items, our curated collection will leave a mark – without the environmental cost.",
          ContactFormName: "Eco-Friendly Gifts for Corporate Gifting",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Recycled Stationery & Office Supplies",
          parapgraphItalic: "Write a Greener Future with Recycled Stationery! ",
          sectionparagraphText: (
            <>
              <p>
                Practical and sustainable office essentials that inspire productivity while protecting the planet. 
              </p>
              <p>
                Transform your workspace with stationery and office supplies crafted from recycled materials. Perfect for everyday use or corporate gifting, these eco-friendly products help reduce waste without compromising on quality or style. From notebooks made of recycled paper to pens crafted from repurposed materials, every item is a step toward a more sustainable future. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Recycled Stationery & Office Supplies.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Bamboo & Wooden Products",
          parapgraphItalic: "Celebrate Nature’s Elegance with Bamboo & Wooden Gifts!",
          sectionparagraphText: (
            <>
              <p>
                Durable, stylish, and eco-friendly products to elevate your gifting game.
              </p>
              <p>
                Bamboo and wooden products are the perfect blend of sustainability and sophistication. From elegant desk organizers to functional kitchenware, our range is designed to suit both personal and professional gifting needs. Each product is crafted to highlight the natural beauty of bamboo and wood, making it a thoughtful and timeless choice.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Bamboo & Wooden Products.jpg",
          categoryHeadingLeftSide: "Features That Stand Out",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Eco-Chic Designs.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Eco-Chic Designs</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Biodegradable.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>100% Biodegradable</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Personalization Options.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Personalization Options</b> <br></br>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Features That Matter.jpg",
          NogapHeading: "Features That Matter",
          Heading: [
            {
              ListHeading: "Sustainable Notebooks",
              ListParagraph:
                "Designed with recycled paper and minimalist aesthetics for an eco-conscious appeal.",
            },
            {
              ListHeading: "Eco-Friendly Writing Tools",
              ListParagraph:
                "Pens, pencils, and markers crafted from recycled and biodegradable materials.",
            },
            {
              ListHeading: "Corporate Personalization",
              ListParagraph:
                "Add your logo or message to promote your brand's commitment to sustainability.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Eco-Friendly Tech Accessories.jpg",
          NogapHeading: "Eco-Friendly Tech Accessories",
          paragraphItalic: "Power Up Sustainably with Eco-Friendly Tech Accessories! ",
          paragraphDetail: (
            <>
              <p>
              Tech meets sustainability with innovative, eco-conscious gadgets. 
              </p>
              <p>
                Upgrade your tech game while being mindful of the environment with our eco-friendly tech accessories. Crafted from sustainable materials like bamboo, cork, and recycled plastics, these products blend innovation with responsibility. From wireless chargers to portable speakers, every item is designed to meet your tech needs with minimal impact on the planet. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Inspire",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Sustainable Materials.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Sustainable Materials</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Innovative Designs.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Innovative Designs</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/Custom Branding.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Custom Branding</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/logo-printing.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/engraving.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/Eco-Friendly Gifts for Corporate Gifting/color-matching.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>Eco-Friendly Gifts for Corporate Gifting</title>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
      Support your corporate values with sustainable gifts that align with your company’s eco-conscious mission.
      </p>
    </>
  );
};

export default EcofriendlyGiftsforcorporategifting;